import { render } from "./CreateVoucher.vue?vue&type=template&id=85139b00&scoped=true"
import script from "./CreateVoucher.vue?vue&type=script&lang=js"
export * from "./CreateVoucher.vue?vue&type=script&lang=js"

import "./CreateVoucher.vue?vue&type=style&index=0&id=85139b00&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85139b00"]])

export default __exports__